import type { UserModule } from '../types';
import { testId } from '@/directives/testId';
import { focusOnClick } from '@/directives/focusOnClick';

export const install: UserModule = ({ app }) => {
    app.directive('test-id', testId);
    app.directive('focus-on-click', focusOnClick);
};
